export const Format_Phone = /^[0-9\b]+$/;
